export enum Breakpoints {
  L = 'L',
  XL = 'XL',
  XXL = 'XXL'
}
